var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PreLoginView',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.initLoading)?_c('ListLoader'):(_vm.step == 'start')?_c('NovaStart',{attrs:{"buttonTitle":_vm.buttonTitle}}):(_vm.step == 'email')?_c('NovaEmailForm'):(_vm.step == 'schedule')?_c('NovaScheduleForm'):(_vm.step == 'success')?_c('NoveStatus'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }